import { REVIEW_URL } from "../constants";
import { apiSlice } from "./apiSlice";

export const reviewApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getTopOrderReviews: builder.query({
            query: () => ({
                url: `${REVIEW_URL}/orderreviews`
            }),
            providesTags: ['Review'],
            keepUnusedDataFor: 5
        }),
        getTopProductReviews: builder.query({
            query: () => ({
                url: `${REVIEW_URL}/productreviews`
            }),
            providesTags: ['Review'],
            keepUnusedDataFor: 5
        })
    })
})

export const {
    useGetTopOrderReviewsQuery,
    useGetTopProductReviewsQuery
} = reviewApiSlice;